import { render } from "./ProjectSummaryCard.vue?vue&type=template&id=9bfa77c6"
import script from "./ProjectSummaryCard.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__